
import XHeader from 'vux/src/components/x-header/index.vue'


export default {
components: {
XHeader
},
data () {
return {
};
}
};



// WEBPACK FOOTER //
// ./src/components/exChange/TaxRefund.vue